import React from 'react';
import { useLanguage } from '../contexts/LanguageContext';
import { images } from '../data/images';
export function CoreConcept() {
  const {
    t
  } = useLanguage();
  const c = t.concept;
  return <section aria-labelledby="concept-title" className="scroll-mt-20 bg-cream py-24 md:py-32" data-id="element-66" data-mp="3rom0ccdpfidx">
      <div className="mx-auto grid max-w-7xl items-center gap-14 px-6 md:px-10 lg:grid-cols-12 lg:gap-20" data-id="element-67" data-mp="aq2m4x2he9m">
        <figure className="order-2 overflow-hidden rounded-[28px] bg-mist lg:order-1 lg:col-span-5" data-id="element-68" data-mp="4ckzmx7yt5hl">
          <img src={images.concept} alt={c.imageAlt} loading="lazy" className="aspect-[4/5] h-full w-full object-cover" data-id="element-69" data-mp="9a39cptt3oqn" />
        </figure>

        <div className="order-1 lg:order-2 lg:col-span-7" data-id="element-70" data-mp="j9c3pjsl35dj">
          <h2 id="concept-title" className="font-display text-[30px] font-medium tracking-[-0.01em] text-ink md:text-[36px]" data-id="element-71" data-mp="j6psna6hi7qk">
            {c.title}
          </h2>
          <p className="mt-6 max-w-2xl font-serif text-[26px] leading-[1.35] text-ink md:text-[34px]" data-id="element-72" data-mp="2l29yvm9u2a1n">
            {c.lead}
          </p>
          <div className="mt-10 grid gap-x-10 gap-y-6 text-[16.5px] text-muted md:grid-cols-2" data-id="element-73" data-mp="24w1z3sqg4d2r">
            {c.paragraphs.map(p => <p key={p} data-id="element-74" data-mp="1zxicrr7xwz9v">{p}</p>)}
          </div>
          <dl className="mt-12 grid grid-cols-3 gap-6 border-t border-line pt-8" data-id="element-75" data-mp="1uyxehxc90po2">
            {c.facts.map(f => <div key={f.label} className="flex flex-col-reverse" data-id="element-76" data-mp="2sklcgmocrg1p">
                <dt className="mt-1 text-[13px] leading-snug text-muted" data-id="element-77" data-mp="2nmbgi9ut0bf1">{f.label}</dt>
                <dd className="font-display text-[22px] font-medium text-ink md:text-[28px]" data-id="element-78" data-mp="2ingmscvat2g5">
                  {f.value}
                </dd>
              </div>)}
          </dl>
        </div>
      </div>
    </section>;
}